export default () => {

  document.addEventListener('DOMContentLoaded', function () {
    var toggleElements = document.querySelectorAll('[data-controller="open-toggle"]');
  
    toggleElements.forEach(function (element) {
      var target = element.querySelector('[data-open-toggle-target="target"]');
      var button = element.querySelector('[data-open-toggle-target="button"]');

      if (!target || !button) return;
      
      button.addEventListener('click', function () {
        target.classList.toggle('open');
      });
    });
  });

};
